import { StepValue } from './step-value';

export interface DynamicConditionalActionChainArgs {
  description?: string;
  type: 'DynamicConditionalActionChainArgs';
  steps: StepValue[];
}

export function isDynamicConditionalActionChainArgs(
  value: unknown,
): value is DynamicConditionalActionChainArgs {
  const keys: (keyof DynamicConditionalActionChainArgs)[] = ['type', 'steps'];
  return (
    value !== undefined &&
    value !== null &&
    typeof value === 'object' &&
    keys.every((key) => key in value)
  );
}
